import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CmsPostContainerModel, CmsPostImageContainerModel } from '../../../../../../models/aggregates/erp/cms-post';
import {
  CmsPostCriteriaModelQuery, CmsPostQueryCriteriaClass
} from '../../../criteria';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';


import { Observable } from 'rxjs';
import { Optional } from 'typescript-optional';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })
export class CmsPostImageService extends BaseApiPublicLoginTemplateService<
  CmsPostImageContainerModel,
  CmsPostImageContainerModel,
  CmsPostImageContainerModel
> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post_images/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post_images/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post_images/' + BaseApiTemplateService.PUBLIC_EP;
  }
  getCmsPostImageByCriteria(
    visa: ApiVisa,
    criteria?: CmsPostQueryCriteriaClass
  ): Observable<ApiResponseModel<CmsPostContainerModel>> {
    const buildDocCriteria = new CmsPostCriteriaModelQuery(criteria);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<CmsPostContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  uploadImageFromMediaLibrary(container, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post_images/' + BaseApiTemplateService.BACKOFFICE_EP + '/' + 'create-from-media-library';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/create-from-media-library';
    }
    return this.httpClient.post(url, container, this.getHttpHeader(visa));
  }

  uploadImageToMediaLibrary(container, visa: ApiVisa) {
    let url = this.apiUrl + '/create-to-media-library';
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/create-to-media-library';
    }
    return this.httpClient.post(url, container, this.getHttpHeader(visa));
  }

  updateImage(formData: FormData, imageGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post_images/replace-file/' + BaseApiTemplateService.BACKOFFICE_EP + '/' + imageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'post_images/replace-file/' + BaseApiTemplateService.BACKOFFICE_EP + '/' + imageGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImage(formData: FormData, visa: ApiVisa, postfiletype) {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
      if (postfiletype) {
        url += '?' + 'postfiletype=' + postfiletype;
      }
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  getImageDetailsByGuid(imageGuid, visa: ApiVisa) {
    let url = this.apiUrl + imageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/" + imageGuid;
    }
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }

  getFileByGuid(imageGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = this.apiUrl + imageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + "/" + imageGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  static filesToFormData(
    files: File[],
    formDataKeyValue: Optional<string>
  ): FormData {
    let formData = new FormData();
    if (!files || files.length === 0) return formData;
    files.forEach((file) =>
      formData.append(formDataKeyValue.orElse("files"), file)
    );
    return formData;
  }
  private static fileToFormData(
    file: File,
    formDataKeyValue: Optional<string>
  ): FormData {
    return CmsPostImageService.filesToFormData([file], formDataKeyValue);
  }

  replaceFile(
    file: File,
    fileImageGuid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<CmsPostContainerModel>> {
    let formData = CmsPostImageService.fileToFormData(
      file,
      Optional.of("file")
    );
    let url = this.apiUrl + "/replace-file/" + fileImageGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/replace-file/" +
        fileImageGuid;
    }
    return this.httpClient.put<BasicApiResponseModel<CmsPostContainerModel>>(
      url,
      formData,
      this.getHttpHeader(visa)
    );
  }

  // addFile(
  //   files: File[],
  //   hdrGuid: string,
  //   visa: ApiVisa
  // ): Observable<BasicApiResponseModel<CmsPostContainerModel>> {
  //   let formData = CmsPostImageService.filesToFormData(
  //     files,
  //     Optional.of("files")
  //   );
  //   let url = this.apiUrl + "/add-files/" + hdrGuid;
  //   if (this.endpoint_path && visa.api_domain_url) {
  //     url = visa.api_domain_url + this.endpoint_path + "/add-files/" + hdrGuid;
  //   }
  //   return this.httpClient.put<BasicApiResponseModel<CmsPostContainerModel>>(
  //     url,
  //     formData,
  //     this.getHttpHeader(visa)
  //   );
  // }
}
